import { render } from "./idAuth.vue?vue&type=template&id=0c16a598&scoped=true"
import script from "./idAuth.vue?vue&type=script&lang=js"
export * from "./idAuth.vue?vue&type=script&lang=js"

import "./idAuth.vue?vue&type=style&index=0&id=0c16a598&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c16a598"]])

export default __exports__